import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
    selector: 'app-version-alert',
    template: `
<div id="container" class="mat-simple-snackbar" role="alert">
  <div class="mat-simple-snackbar-action">
    <span>JSuite Vault API version is not matching with Vault API version. Please<span class="mat-simple-snackbar-action-button" (click)="performAction( data.maxVersion)">Update</span></span>
   
  </div>
 
</div>
`,
    styleUrls: ['./version-alert.component.scss'],
    standalone: false
})
export class VersionAlertComponent implements OnInit {

  constructor(private snackBarRef: MatSnackBarRef<VersionAlertComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private loginService: LoginService,
    private snackbar: MatSnackBar,
    private spinner: NgxUiLoaderService) { }

  ngOnInit(): void {
  }

  performAction(maxversion) {
    this.snackBarRef.dismiss();
    const result = window.confirm("Are you sure you want to update the JSuite Vault API version?");
    if(result){
      this.spinner.start();
     this.loginService.updateVaultVersion(maxversion,localStorage.getItem("dnsName")).subscribe(res=>{
      this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", {duration: 5000});
     
     })
    }
  }

  dismissSnackbar() {
    // Dismiss the snackbar when the cancel button is clicked
    this.snackBarRef.dismiss();
  }
}
